/*
 * AdmissionTemplate resource
 * Generated resources from cadence/scripts/generate
 */
export * from './admission-template-list';
export * from './admission-template-create';
export * from './admission-template-update';
export * from './admission-template-delete';
